import React from 'react';
import PropTypes from 'prop-types';

const InlineError = ({ text }) => <div className="field-error">{text}</div>;

InlineError.propTypes = {
    text: PropTypes.string.isRequired,
};

export default InlineError;



// WEBPACK FOOTER //
// ./src/components/widgets/InlineError.js